var MarginSize = {
  ZERO: 0,
  FOUR: 4,
  EIGHT: 8,
  TWELVE: 12,
  SIXTEEN: 16
};
var VoteStatus = {
  POSITIVE: "upvote",
  NEGATIVE: "downvote",
  NONE: null
};
var CreateMoimStep = {
  MOIM_NAME: 1,
  MOIM_DOMAIN: 2,
  MOIM_ACCESS: 3,
  MOIM_ICON: 4,
  USER_NAME: 5,
  MOIM_RESULT: 6
};
var MatchRouting = {
  FORUM: "FORUM",
  FORUM_SHOW: "FORUM_SHOW",
  CONVERSATION: "CONVERSATION",
  SUBMOIM_LIST: "SUBMOIM_LIST",
  VIEW: "VIEW",
  DIRECT_MESSAGE: "DIRECT_MESSAGE",
  COMMERCE: "COMMERCE",
  COMMERCE_CATEGORY: "COMMERCE_CATEGORY",
  NOT_MATCHED: "NOT_MATCHED"
};
var PermissionDeniedFallbackType = {
  FULLSCREEN_DIALOG: "FULLSCREEN_DIALOG",
  SCREEN: "SCREEN",
  ALERT: "ALERT",
  CUSTOM: "CUSTOM",
  NONE: "NONE"
};
var NotificationType = {
  ALL: "all",
  MENTION: "mention"
};
var NotificationGroupKeyType = {
  TODAY: "TODAY",
  YESTERDAY: "YESTERDAY",
  OLDER: "OLDER"
};
var ItemIdTypes = {
  MESSAGE: "M",
  THREAD: "T",
  COMMENT: "R",
  DRAFT: "X",
  PRODUCT: "CP"
};
var ChannelIdTypes = {
  Forum: "Q",
  Conversation: "C",
  DM: "D",
  Block: "I",
  SubMoim: "J"
};
var PostShowTypes = {
  DEFAULT: "DEFAULT",
  MODAL: "MODAL",
  FULL_SCREEN: "FULL_SCREEN"
};
var UserStatusTypes = {
  ACTIVE: 0,
  DEACTIVATED: 1,
  PENDING: 2,
  WAITING_FOR_APPROVAL: 3,
  REJECTED: 4
};
var ElementThemeColorValueTypes = {
  PRIMARY_MAIN: "PRIMARY_MAIN",
  PRIMARY_DARK: "PRIMARY_DARK",
  PRIMARY_LIGHT: "PRIMARY_LIGHT",
  SECONDARY_MAIN: "SECONDARY_MAIN",
  SECONDARY_DARK: "SECONDARY_DARK",
  SECONDARY_LIGHT: "SECONDARY_LIGHT",
  BLACK: "BLACK",
  WHITE: "WHITE"
};
var ThemeColorScaleTypes = {
  BLACK: "BLACK",
  WHITE: "WHITE"
};
var SearchResultTabTypes = {
  POST: "post",
  MESSAGE: "message",
  MEMBER: "member",
  GROUP: "group",
  PRODUCT: "product"
};
var CommerceCurrencyTypes = {
  USD: "USD",
  KRW: "KRW",
  SGD: "SGD"
};
var BlockchainCurrencyTypes = {
  MATIC: "MATIC",
  ETH: "ETH",
  LINK: "LINK",
  USDT: "USDT",
  USDC: "USDC",
  APE: "APE",
  SAND: "SAND",
  SHIB: "SHIB",
  NEAR: "NEAR",
  AVAX: "AVAX",
  MANA: "MANA"
};
var ThemeMode = {
  LIGHT: "LIGHT",
  DARK: "DARK"
};
var NetworkTypes = {
  POLYGON: "POLYGON",
  ETHEREUM: "ETHEREUM",
  MUMBAI: "MUMBAI"
};

export { BlockchainCurrencyTypes, ChannelIdTypes, CommerceCurrencyTypes, CreateMoimStep, ElementThemeColorValueTypes, ItemIdTypes, MarginSize, MatchRouting, NetworkTypes, NotificationGroupKeyType, NotificationType, PermissionDeniedFallbackType, PostShowTypes, SearchResultTabTypes, ThemeColorScaleTypes, ThemeMode, UserStatusTypes, VoteStatus };
